export class Gewerbe {
  art = "";
  beschreibung = "";
  flaeche: number | null;

  constructor() {
    this.flaeche = null;
  }
}
